/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: generic_task.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  CreateGenericTaskRequest,
  CreateGenericTaskResponse,
  GetGenericTaskRequest,
  GetGenericTaskResponse,
  GetGenericTasksRequest,
  GetGenericTasksResponse,
  UpdateGenericTaskRequest,
  UpdateGenericTaskResponse,
} from '../types/generic_task';

export const createGenericTaskService = (transport: Transport) => ({
  async createGenericTask(
    request: CreateGenericTaskRequest,
    options: RequestOptions = {},
  ): Promise<CreateGenericTaskResponse> {
    const { organization_id, program_id, case_record_id, ...body } = request;
    const url = getApiPath(API_METHODS.GenericTaskService.CreateGenericTask, {
      organization_id,
      program_id,
      case_record_id,
    });
    return transport.post<CreateGenericTaskResponse>(url, body, options);
  },

  async updateGenericTask(
    request: UpdateGenericTaskRequest,
    options: RequestOptions = {},
  ): Promise<UpdateGenericTaskResponse> {
    const { organization_id, program_id, case_record_id, generic_task_id, ...body } = request;
    const url = getApiPath(API_METHODS.GenericTaskService.UpdateGenericTask, {
      organization_id,
      program_id,
      case_record_id,
      generic_task_id,
    });
    return transport.post<UpdateGenericTaskResponse>(url, body, options);
  },

  async getGenericTask(
    request: GetGenericTaskRequest,
    options: RequestOptions = {},
  ): Promise<GetGenericTaskResponse> {
    const { organization_id, program_id, case_record_id, generic_task_id } = request;
    const url = getApiPath(API_METHODS.GenericTaskService.GetGenericTask, {
      organization_id,
      program_id,
      case_record_id,
      generic_task_id,
    });
    return transport.get<GetGenericTaskResponse>(url, options);
  },

  async getGenericTasks(
    request: GetGenericTasksRequest,
    options: RequestOptions = {},
  ): Promise<GetGenericTasksResponse> {
    const { organization_id, program_id, case_record_id, ...params } = request;
    const url = getApiPath(API_METHODS.GenericTaskService.GetGenericTasks, {
      organization_id,
      program_id,
      case_record_id,
    });
    return transport.get<GetGenericTasksResponse>(url, { params, ...options });
  },
});

export type GenericTaskService = ReturnType<typeof createGenericTaskService>;
